import script from "./cards.vue?vue&type=script&setup=true&lang=js"
export * from "./cards.vue?vue&type=script&setup=true&lang=js"

import "./cards.vue?vue&type=style&index=0&id=042fe3fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042fe3fe"]])

export default __exports__